import styled from 'styled-components'
import { Button } from 'reactstrap'

export const IconImage = styled.img`
    width: 1.5rem;
`

export const StyledButton = styled(Button)`
    border-radius: 2rem!important;
`